export default [
  {
    name: "A: Arc pistol x10",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "0dca1f10-7ef4-4059-81c3-649dad4b6d80",
        modelTypeName: null,
        unitId: "0bcece75-8c79-4f2a-add8-8dd7fba04419",
      },
    ],
    units: [
      {
        id: "0bcece75-8c79-4f2a-add8-8dd7fba04419",
        leader: false,
        name: "A: Arc pistol x10 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Arc pistol",
                type: "Ranged",
                attacks: 1,
                strength: 5,
                ap: -2,
                damage: 1,
                abilities: [
                  {
                    description: "Set damage to 2 (VEHICLE only)",
                    id: "213184f0-3c81-4743-88a4-aa4dc44ee9e1",
                    conditions: [
                      {
                        data: {
                          keywords: ["VEHICLE"],
                        },
                        preselected: false,
                        text: "Keywords (only)",
                        type: "keywordsOnly",
                      },
                    ],
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: 2,
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                  {
                    description:
                      "Always wound on a 4+ (unmodified) (VEHICLE only)",
                    id: "e449f939-5dcc-40a4-a1a6-a3dfc03ab333",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "4",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                      },
                      {
                        data: {
                          keywords: ["VEHICLE"],
                        },
                        preselected: false,
                        text: "Keywords (only)",
                        type: "keywordsOnly",
                      },
                    ],
                    scope: ["weapon"],
                    effect: {
                      data: {
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                        crit: false,
                      },
                      text: "Override requirements",
                      type: "overrideReqs",
                    },
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "b42ff10e-5b04-4165-8b89-a3cd82c99796",
                bs: 3,
                ws: null,
                nameUnique: "Arc pistol",
              },
            ],
            id: "0dca1f10-7ef4-4059-81c3-649dad4b6d80",
            name: "A: Arc pistol x10 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["b42ff10e-5b04-4165-8b89-a3cd82c99796"],
  },
  {
    name: "A: Arc rifle x10",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "b7c35e68-fa58-410c-9ddf-4e05270ce68f",
        modelTypeName: null,
        unitId: "e1a556b2-9c95-407e-9e46-176ae5bcecdc",
      },
    ],
    units: [
      {
        id: "e1a556b2-9c95-407e-9e46-176ae5bcecdc",
        leader: false,
        name: "A: Arc rifle x10 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Arc rifle",
                type: "Ranged",
                attacks: 1,
                strength: 6,
                ap: -2,
                damage: "D3",
                abilities: [
                  {
                    description: "Set damage to 3 (VEHICLE only)",
                    id: "9fd21c4f-86b2-4825-a5aa-a1510c3b73d6",
                    conditions: [
                      {
                        data: {
                          keywords: ["VEHICLE"],
                        },
                        preselected: false,
                        text: "Keywords (only)",
                        type: "keywordsOnly",
                      },
                    ],
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: 3,
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                  {
                    description:
                      "Always wound on a 4+ (unmodified) (VEHICLE only)",
                    id: "963296fc-c53c-45a2-ae4b-5dfb0ead4c65",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "4",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                      },
                      {
                        data: {
                          keywords: ["VEHICLE"],
                        },
                        preselected: false,
                        text: "Keywords (only)",
                        type: "keywordsOnly",
                      },
                    ],
                    scope: ["weapon"],
                    effect: {
                      data: {
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                        crit: false,
                      },
                      text: "Override requirements",
                      type: "overrideReqs",
                    },
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                  {
                    aliases: [
                      {
                        name: "Rapid fire 1",
                        type: "reserved",
                      },
                    ],
                    conditions: [
                      {
                        text: "Range",
                        type: "range",
                        data: {
                          range: {
                            title: "Within half range",
                            key: "withinHalfRange",
                          },
                        },
                        description: "Check attack range.",
                        preselected: false,
                      },
                    ],
                    description: "Increase attacks by 1 (within half range)",
                    effect: {
                      text: "Increase weapon attacks",
                      type: "increaseWeaponAttacks",
                      data: {
                        increaseWeaponAttacksValue: 1,
                        applyToExtraAttacks: false,
                      },
                    },
                    id: "e7bc0390-66a9-4ff6-ba5a-591e39d281fb",
                    scope: ["weapon"],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "b7dc1b5d-8ffb-44b1-ba51-dee23be81a41",
                bs: 3,
                ws: null,
                nameUnique: "Arc rifle",
              },
            ],
            id: "b7c35e68-fa58-410c-9ddf-4e05270ce68f",
            name: "A: Arc rifle x10 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["b7dc1b5d-8ffb-44b1-ba51-dee23be81a41"],
  },
  {
    name: "A: Psychic",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: null,
    computed_points: null,
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: 0,
    computed_wounds: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "2669ab66-d45c-4e00-84b1-bb8af594fb31",
        modelTypeName: null,
        unitId: "5f993e93-a65d-418c-b559-826353a3d019",
      },
    ],
    units: [
      {
        abilities: [],
        id: "5f993e93-a65d-418c-b559-826353a3d019",
        leader: false,
        name: "A: Psychic > Unit 1",
        points: null,
        model_types: [
          {
            ignore: null,
            invuln: null,
            keywords: [],
            modelCount: null,
            save: null,
            toughness: null,
            weapons: [
              {
                name: "Mind gun",
                countPerUnit: 1,
                type: "Ranged",
                attacks: 20,
                bs: 3,
                strength: 6,
                ap: -2,
                damage: 1,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Psychic",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    conditions: [],
                    description: "Psychic",
                    effect: {
                      text: "Special",
                      type: "special",
                      data: {
                        option: {
                          title: "Psychic",
                          key: "psychic",
                        },
                      },
                    },
                    scope: ["weapon"],
                    id: "a16864aa-d819-4819-9e3a-ca8c1e47f564",
                    sharedWithAllUnits: false,
                  },
                ],
                id: "25fdbf05-7da9-43dc-950d-6efdbbfa55db",
                nameUnique: "Mind gun",
              },
              {
                name: "Baseline",
                countPerUnit: 1,
                type: "Ranged",
                attacks: 20,
                bs: 3,
                strength: 6,
                ap: -2,
                damage: 1,
                id: "342aec86-92b9-4f57-b006-92034e9a8083",
                nameUnique: "Baseline",
                abilities: [],
              },
            ],
            wounds: null,
            id: "2669ab66-d45c-4e00-84b1-bb8af594fb31",
            name: "A: Psychic > Unit 1 > Model type 1",
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "25fdbf05-7da9-43dc-950d-6efdbbfa55db",
      "342aec86-92b9-4f57-b006-92034e9a8083",
    ],
  },
  {
    name: "A: Squat guns",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 0,
    computed_points: 0,
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: 0,
    computed_wounds: 0,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "df85089c-4f72-42d6-a2da-69f8a1a8ed5b",
        modelTypeName: "A: Squat guns",
        unitId: "e0784fe4-69dc-4ba3-a36d-ce22bfad999f",
      },
    ],
    units: [
      {
        abilities: [],
        id: "e0784fe4-69dc-4ba3-a36d-ce22bfad999f",
        leader: false,
        name: "A: Squat guns > Unit 1",
        points: null,
        model_types: [
          {
            id: "df85089c-4f72-42d6-a2da-69f8a1a8ed5b",
            ignore: null,
            invuln: null,
            keywords: [],
            modelCount: null,
            name: "A: Squat guns > Unit 1 > Model type 1",
            save: null,
            toughness: null,
            weapons: [
              {
                name: "Magna-rail baseline",
                countPerUnit: "4",
                type: "Ranged",
                attacks: 2,
                bs: 3,
                strength: 9,
                ap: -4,
                damage: 5,
                id: "d1ad048f-fe05-49f8-99c4-17502b6c141d",
                nameUnique: "Magna-rail baseline",
                abilities: [],
              },
              {
                name: "Magna-rail",
                countPerUnit: "4",
                type: "Ranged",
                attacks: 2,
                bs: 3,
                strength: 9,
                ap: -4,
                damage: 5,
                abilities: [
                  {
                    conditions: [
                      {
                        text: "Critical hit/wound",
                        type: "crit",
                        data: {
                          crit: {
                            title: "Critical wound",
                            key: "woundRoll",
                          },
                        },
                        description: 'Require a hit or wound to be "critical".',
                        preselected: false,
                        scope: ["global", "profile", "weapon"],
                      },
                    ],
                    description: "Critical wound : disable save (inc. invuln)",
                    effect: {
                      text: "Disable mechanic",
                      type: "disableAbility",
                      data: {
                        option: {
                          title: "Disable save (inc. invuln)",
                          key: "disableSave",
                        },
                      },
                    },
                    scope: ["weapon"],
                    id: "fb3169f7-7f8a-4825-a357-1c88e779610a",
                    aliases: [
                      {
                        name: "Devastating wounds",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "258e4136-b975-424d-9a4d-ea812f6df782",
                nameUnique: "Magna-rail",
              },
              {
                name: "Conversion Beamer",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 3,
                strength: 8,
                ap: -3,
                damage: 4,
                abilities: [
                  {
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Hit roll",
                            key: "hitRoll",
                          },
                          rollReq: {
                            title: "Successful roll",
                            key: "successfulRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: null,
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                      {
                        data: {
                          range: {
                            title: "Over half range",
                            key: "overHalfRange",
                          },
                        },
                        preselected: false,
                        text: "Range",
                        type: "range",
                        required: false,
                      },
                    ],
                    description:
                      "Successful hit roll : 1 extra hit (over half range)",
                    effect: {
                      data: {
                        option: {
                          title: "Extra hits",
                          key: "extraHits",
                        },
                        extrasValue: 1,
                      },
                      text: "Generate extras",
                      type: "generateExtras",
                    },
                    scope: ["weapon"],
                    id: "d4a40790-35ed-4f3c-a4a4-f906a15fc4df",
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "25ef40c4-a221-4df1-a8b2-bd48f6f5d3f9",
                bs: 3,
                ws: null,
                nameUnique: "Conversion Beamer",
              },
            ],
            wounds: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "A: Weapon ability: Always hit",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "bd1ba14f-8a25-4dab-8673-69c6a41ebabc",
        modelTypeName: null,
        unitId: "450a6799-6d91-455f-aea6-8f8c003b0c3c",
      },
    ],
    units: [
      {
        id: "450a6799-6d91-455f-aea6-8f8c003b0c3c",
        leader: false,
        name: "A: Weapon ability: Always hit > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Weapon with ability",
                type: "Ranged",
                attacks: "D6",
                strength: 4,
                ap: -1,
                damage: 1,
                abilities: [
                  {
                    description: "Always hit",
                    id: "b2c3589f-e370-4985-af43-4329a4209a6d",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        irrespective: false,
                        outcome: {
                          title: "Hit",
                          key: "hit",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                        crit: false,
                      },
                      text: "Override requirements",
                      type: "overrideReqs",
                    },
                    conditions: [],
                    aliases: [
                      {
                        name: "Torrent",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 5,
                id: "8aa426cd-bd6a-4909-b993-d9c678f30225",
                bs: null,
                ws: null,
                nameUnique: "Weapon with ability",
              },
            ],
            id: "bd1ba14f-8a25-4dab-8673-69c6a41ebabc",
            name: "A: Weapon ability: Always hit > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["8aa426cd-bd6a-4909-b993-d9c678f30225"],
  },
  {
    name: "A: Weapon ability: ANTI AIR",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "fc814d38-50d5-4851-9508-46aea1387168",
        modelTypeName: null,
        unitId: "ad47c2d7-df17-4bbe-874d-cdd8cbdde974",
      },
    ],
    units: [
      {
        id: "ad47c2d7-df17-4bbe-874d-cdd8cbdde974",
        leader: false,
        name: "A: Weapon ability: ANTI AIR > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Weapon with ANTI AIR",
                type: "Ranged",
                attacks: 3,
                strength: 7,
                ap: -1,
                damage: 2,
                abilities: [
                  {
                    description: "+1 to hit roll (AIRCRAFT only)",
                    id: "d5bd4255-6913-4efb-b448-c3211cfccdc3",
                    conditions: [
                      {
                        data: {
                          keywords: ["AIRCRAFT"],
                        },
                        preselected: false,
                        text: "Keywords (only)",
                        type: "keywordsOnly",
                      },
                    ],
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        operator: {
                          title: "Add",
                          key: "add",
                        },
                        relativeValue: 1,
                      },
                      text: "Modify (relative)",
                      type: "modifyRelative",
                    },
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 5,
                id: "633fd727-cec2-4426-a25d-3c728324be6a",
                bs: 3,
                ws: null,
                nameUnique: "Weapon with ANTI AIR",
              },
              {
                name: "Weapon with ANTI AIR:LEGACY",
                type: "Ranged",
                attacks: 3,
                strength: 7,
                ap: -1,
                damage: 2,
                abilities: [
                  {
                    description: "+1 to hit roll (FLY only)",
                    id: "3da50691-8c1a-490a-a38e-c95b4edcd4a3",
                    conditions: [
                      {
                        data: {
                          keywords: ["FLY"],
                        },
                        preselected: false,
                        text: "Keywords (only)",
                        type: "keywordsOnly",
                      },
                    ],
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        operator: {
                          title: "Add",
                          key: "add",
                        },
                        relativeValue: 1,
                      },
                      text: "Modify (relative)",
                      type: "modifyRelative",
                    },
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                  {
                    description: "-1 to hit roll (excludes FLY)",
                    id: "5583263c-6af5-4ca7-8d70-d44f5a8f0cb9",
                    conditions: [
                      {
                        data: {
                          keywords: ["FLY"],
                        },
                        preselected: false,
                        text: "Keywords (excludes)",
                        type: "keywordsExcludes",
                      },
                    ],
                    scope: ["weapon"],
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        operator: {
                          title: "Subtract",
                          key: "subtract",
                        },
                        relativeValue: 1,
                      },
                      text: "Modify (relative)",
                      type: "modifyRelative",
                    },
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 5,
                id: "dfd2ca37-c31a-4a8d-bae7-63c6f8f5f855",
                bs: 3,
                ws: null,
                nameUnique: "Weapon with ANTI AIR:LEGACY",
              },
            ],
            id: "fc814d38-50d5-4851-9508-46aea1387168",
            name: "A: Weapon ability: ANTI AIR > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "633fd727-cec2-4426-a25d-3c728324be6a",
      "dfd2ca37-c31a-4a8d-bae7-63c6f8f5f855",
    ],
  },
  {
    name: "A: Weapon ability: Blast",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Melee", "Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "346c3a21-6ad2-4433-9600-23101b40e609",
        modelTypeName: null,
        unitId: "14275640-275f-4f89-94ed-c70340b57174",
      },
    ],
    units: [
      {
        id: "14275640-275f-4f89-94ed-c70340b57174",
        leader: false,
        name: "A: Weapon ability: Blast > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Ranged weapon with Blast",
                type: "Ranged",
                attacks: "D3+3",
                strength: 5,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Blast",
                    id: "bdbff9b0-51a8-4494-afb0-00d1dbf91750",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        option: {
                          title: "Blast",
                          key: "blast",
                        },
                      },
                      text: "Special",
                      type: "special",
                    },
                    conditions: [],
                    aliases: [
                      {
                        name: "Blast",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 1,
                id: "5cc725c3-65f6-4029-bd57-8ac530d66b7b",
                bs: 3,
                ws: null,
                nameUnique: "Ranged weapon with Blast",
              },
              {
                name: "Melee weapon with Blast",
                type: "Melee",
                attacks: "D3+3",
                strength: 5,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description: "Blast",
                    id: "1485579f-8466-4425-b87b-c6cd06f353c1",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        option: {
                          title: "Blast",
                          key: "blast",
                        },
                      },
                      text: "Special",
                      type: "special",
                    },
                    conditions: [],
                    aliases: [
                      {
                        name: "Blast",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 1,
                id: "d5f33b40-ab07-4096-b093-ecc5046d8918",
                bs: null,
                ws: 3,
                nameUnique: "Melee weapon with Blast",
              },
            ],
            id: "346c3a21-6ad2-4433-9600-23101b40e609",
            name: "A: Weapon ability: Blast > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: ["d5f33b40-ab07-4096-b093-ecc5046d8918"],
    weapons_selected_ranged: ["5cc725c3-65f6-4029-bd57-8ac530d66b7b"],
  },
  {
    name: "A: Weapon ability: Grav",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Melee", "Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "06ed04e1-8a8c-40b9-9c9e-447ad0597b49",
        modelTypeName: null,
        unitId: "922e2e63-051d-40a5-b54e-0b7745c0501a",
      },
    ],
    units: [
      {
        id: "922e2e63-051d-40a5-b54e-0b7745c0501a",
        leader: false,
        name: "A: Weapon ability: Grav > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Melee weapon with Grav: D3",
                type: "Melee",
                attacks: 25,
                strength: 5,
                ap: -3,
                damage: 1,
                abilities: [
                  {
                    conditions: [
                      {
                        data: {
                          defenderChar: {
                            title: "Save",
                            key: "save",
                          },
                          defenderCharValue: "4",
                          defenderCharState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          comparison: {
                            title: "Less than",
                            key: "lessThan",
                          },
                        },
                        preselected: false,
                        text: "Defender characteristic",
                        type: "defenderCharacteristic",
                        required: true,
                      },
                    ],
                    description:
                      "Save (unmodified) is less than 4 : set damage to D3",
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: "D3",
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                    id: "d70318f2-6f57-432f-93ab-84d7e9993ba7",
                  },
                ],
                id: "b34d1cf8-39a6-4c25-8bf2-d67b95907c56",
                countPerUnit: 1,
                bs: null,
                ws: 3,
                nameUnique: "Melee weapon with Grav: D3",
              },
              {
                name: "Ranged weapon with Grav: D3",
                type: "Ranged",
                attacks: 5,
                strength: 5,
                ap: -3,
                damage: 1,
                abilities: [
                  {
                    conditions: [
                      {
                        data: {
                          defenderChar: {
                            title: "Save",
                            key: "save",
                          },
                          defenderCharValue: "4",
                          defenderCharState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          comparison: {
                            title: "Less than",
                            key: "lessThan",
                          },
                        },
                        preselected: false,
                        text: "Defender characteristic",
                        type: "defenderCharacteristic",
                        required: true,
                      },
                    ],
                    description:
                      "Save (unmodified) is less than 4 : set damage to D3",
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: "D3",
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                    id: "9e992c77-ecd9-401b-9169-2cc046cf86e3",
                  },
                ],
                countPerUnit: 5,
                id: "e5858c17-143e-44f1-a096-a61dea0bc42b",
                bs: 3,
                ws: null,
                nameUnique: "Ranged weapon with Grav: D3",
              },
              {
                name: "Ranged weapon with Grav: 2",
                type: "Ranged",
                attacks: 5,
                strength: 5,
                ap: -3,
                damage: 1,
                abilities: [
                  {
                    conditions: [
                      {
                        data: {
                          defenderChar: {
                            title: "Save",
                            key: "save",
                          },
                          defenderCharValue: "4",
                          defenderCharState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          comparison: {
                            title: "Less than",
                            key: "lessThan",
                          },
                        },
                        preselected: false,
                        text: "Defender characteristic",
                        type: "defenderCharacteristic",
                        required: true,
                      },
                    ],
                    description:
                      "Save (unmodified) is less than 4 : set damage to 2",
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: "2",
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                    id: "45aa3163-7239-4310-92a6-1397ad324e4f",
                  },
                ],
                countPerUnit: 5,
                id: "bfb3b3c1-d3d6-481c-9c26-fa2234d8bbe5",
                bs: 3,
                ws: null,
                nameUnique: "Ranged weapon with Grav: 2",
              },
              {
                name: "Ranged weapon with Grav: 3",
                type: "Ranged",
                attacks: 5,
                strength: 5,
                ap: -3,
                damage: 1,
                abilities: [
                  {
                    conditions: [
                      {
                        data: {
                          defenderChar: {
                            title: "Save",
                            key: "save",
                          },
                          defenderCharValue: "4",
                          defenderCharState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          comparison: {
                            title: "Less than",
                            key: "lessThan",
                          },
                        },
                        preselected: false,
                        text: "Defender characteristic",
                        type: "defenderCharacteristic",
                        required: true,
                      },
                    ],
                    description:
                      "Save (unmodified) is less than 4 : set damage to 3",
                    effect: {
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Replace",
                          key: "replace",
                        },
                        absoluteValue: "3",
                      },
                      text: "Modify (absolute)",
                      type: "modifyAbsolute",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                    id: "27221354-5b2e-4aa7-829c-70a5e7989a24",
                  },
                ],
                countPerUnit: 5,
                id: "ad65b2d9-1e41-44bc-8ebd-c8b8560089d9",
                bs: 3,
                ws: null,
                nameUnique: "Ranged weapon with Grav: 3",
              },
            ],
            id: "06ed04e1-8a8c-40b9-9c9e-447ad0597b49",
            name: "A: Weapon ability: Grav > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: ["b34d1cf8-39a6-4c25-8bf2-d67b95907c56"],
    weapons_selected_ranged: [
      "e5858c17-143e-44f1-a096-a61dea0bc42b",
      "bfb3b3c1-d3d6-481c-9c26-fa2234d8bbe5",
      "ad65b2d9-1e41-44bc-8ebd-c8b8560089d9",
    ],
  },
  {
    name: "A: Weapon ability: Melta",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: null,
    computed_points: null,
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: 0,
    computed_wounds: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "d3ccea85-e8f4-4b47-8250-551d764a6da4",
        modelTypeName: null,
        unitId: "ac2c7f74-af16-408d-9c3c-9a21b193da7a",
      },
    ],
    units: [
      {
        abilities: [],
        id: "ac2c7f74-af16-408d-9c3c-9a21b193da7a",
        leader: false,
        name: "A: Weapon ability: Melta > Unit 1",
        points: null,
        model_types: [
          {
            ignore: null,
            invuln: null,
            keywords: [],
            modelCount: null,
            save: null,
            toughness: null,
            weapons: [
              {
                name: "Ranged weapon with MELTA 2",
                countPerUnit: 4,
                type: "Ranged",
                attacks: 2,
                bs: 3,
                strength: 8,
                ap: -4,
                damage: "D6",
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Melta 2",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    conditions: [
                      {
                        text: "Range",
                        type: "range",
                        data: {
                          range: {
                            title: "Within half range",
                            key: "withinHalfRange",
                          },
                        },
                        description: "Check attack range.",
                        preselected: false,
                      },
                    ],
                    description: "+2 to damage (within half range)",
                    effect: {
                      text: "Modify (relative)",
                      type: "modifyRelative",
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Add",
                          key: "add",
                        },
                        relativeValue: 2,
                      },
                    },
                    scope: ["weapon"],
                    id: "cdacb940-2c67-43b9-b81a-736a0b9bc3e5",
                    sharedWithAllUnits: false,
                  },
                ],
                id: "d7732fec-fae8-4e28-b09b-daeef252967c",
                ws: null,
                nameUnique: "Ranged weapon with MELTA 2",
              },
              {
                name: "Ranged weapon with MELTA D3",
                countPerUnit: 4,
                type: "Ranged",
                attacks: 2,
                bs: 3,
                strength: 8,
                ap: -4,
                damage: "D6",
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Melta D3",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    conditions: [
                      {
                        text: "Range",
                        type: "range",
                        data: {
                          range: {
                            title: "Within half range",
                            key: "withinHalfRange",
                          },
                        },
                        description: "Check attack range.",
                        preselected: false,
                      },
                    ],
                    description: "+D3 to damage (within half range)",
                    effect: {
                      text: "Modify (relative)",
                      type: "modifyRelative",
                      data: {
                        application: {
                          title: "Damage",
                          key: "damage",
                        },
                        operator: {
                          title: "Add",
                          key: "add",
                        },
                        relativeValue: "D3",
                      },
                    },
                    scope: ["weapon"],
                    id: "c232f441-664a-422a-a032-d74f1207d7be",
                    sharedWithAllUnits: false,
                  },
                ],
                id: "43a3eefa-60c1-4b81-ab0a-3d7b0c05f91f",
                ws: null,
                nameUnique: "Ranged weapon with MELTA D3",
              },
            ],
            wounds: null,
            id: "d3ccea85-e8f4-4b47-8250-551d764a6da4",
            name: "A: Weapon ability: Melta > Unit 1 > Model type 1",
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "d7732fec-fae8-4e28-b09b-daeef252967c",
      "43a3eefa-60c1-4b81-ab0a-3d7b0c05f91f",
    ],
  },
]
